import API from '../Services/API';
import Model from './Model';
import State from "./State";

const useImports = (alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'imports',
        stateKey: 'imports',
        fetchData: () => API.get('/imports'),
        saveAdditionalData: (imports) => {
            imports.forEach(imp => {
                State.putIfNotExists(['import', imp.id], imp)
            })
        },
        defaultLoadingError: 'Sorry, there was an error loading imports.',
    });
}

const useImport = (importId = null, alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'import',
        stateKey: ['import', importId],
        block: !importId,
        fetchData: () => API.get(`/imports/${importId}`),
        defaultLoadingError: 'Sorry, there was an error loading the import.',
    });
}

export {
    useImports,
    useImport,
}
